import { createTheme } from '@mui/material/styles';
import {mainTheme} from "./main-theme";

export const searchTheme = createTheme(mainTheme, {
  components: {
    MuiInputBase: {
      styleOverrides: {
        root: {
          fontSize: "0.8rem",
        }
      }
    },
  }
});